
import React, { useState } from 'react';

export const GamblingHistorySection: React.FC = () => {
  const [activeEra, setActiveEra] = useState(0);

  const timeline = [
    {
      year: '1994',
      title: 'Рождение онлайн казино',
      description: 'Microgaming запускает первое онлайн казино. Начало эры интернет-гэмблинга.',
      icon: 'ri-computer-line'
    },
    {
      year: '2007',
      title: 'Эра смартфонов',
      description: 'Выход iPhone открывает новые возможности для мобильных казино онлайн.',
      icon: 'ri-smartphone-line'
    },
    {
      year: '2010',
      title: 'HTML5 революция',
      description: 'Переход на HTML5 позволяет играть в браузере без Flash.',
      icon: 'ri-code-s-slash-line'
    },
    {
      year: '2015',
      title: 'Live казино',
      description: 'Evolution Gaming делает live-игры доступными на мобильных устройствах.',
      icon: 'ri-live-line'
    },
    {
      year: '2020',
      title: 'Криптовалюты',
      description: 'Массовое внедрение Bitcoin и других криптовалют в онлайн казино.',
      icon: 'ri-bit-coin-line'
    },
    {
      year: '2024',
      title: 'AI и персонализация',
      description: 'Искусственный интеллект персонализирует игровой опыт.',
      icon: 'ri-robot-line'
    }
  ];

  const trends = [
    {
      title: 'Мобильный трафик',
      value: '78%',
      description: 'игроков используют смартфоны',
      trend: 'up',
      color: 'rose'
    },
    {
      title: 'Криптоплатежи',
      value: '45%',
      description: 'рост за последний год',
      trend: 'up',
      color: 'amber'
    },
    {
      title: 'Live казино',
      value: '62%',
      description: 'предпочитают живых дилеров',
      trend: 'up',
      color: 'emerald'
    },
    {
      title: 'Средний возраст',
      value: '28 лет',
      description: 'типичный игрок мобильного казино',
      trend: 'stable',
      color: 'sky'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
            История и тренды
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Эволюция <span className="text-sky-600">мобильных казино онлайн</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            От первых онлайн казино до современных мобильных платформ
          </p>
        </div>

        <div className="mb-16">
          <div className="relative">
            <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2 hidden md:block"></div>
            <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
              {timeline.map((item, index) => (
                <button
                  key={index}
                  onClick={() => setActiveEra(index)}
                  className={`relative flex flex-col items-center cursor-pointer transition-all ${
                    activeEra === index ? 'scale-105' : ''
                  }`}
                >
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-2 transition-all ${
                    activeEra === index
                      ? 'bg-sky-600 text-white shadow-lg'
                      : 'bg-white border-2 border-gray-200 text-gray-400 hover:border-sky-300'
                  }`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <span className={`text-sm font-bold ${
                    activeEra === index ? 'text-sky-600' : 'text-gray-500'
                  }`}>{item.year}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="mt-8 bg-white rounded-2xl shadow-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 bg-sky-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className={`${timeline[activeEra].icon} text-sky-600 text-2xl`}></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {timeline[activeEra].year}: {timeline[activeEra].title}
                </h3>
                <p className="text-gray-600">{timeline[activeEra].description}</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Тренды мобильного гэмблинга 2026
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {trends.map((trend, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md p-6 text-center hover:shadow-lg transition-all"
              >
                <div className={`text-3xl md:text-4xl font-bold mb-2 text-${trend.color}-600`}>
                  {trend.value}
                  {trend.trend === 'up' && (
                    <i className="ri-arrow-up-line text-emerald-500 text-lg ml-1"></i>
                  )}
                </div>
                <div className="text-sm font-semibold text-gray-900 mb-1">{trend.title}</div>
                <div className="text-xs text-gray-500">{trend.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
